import $ from 'jquery'
import reqwest from 'reqwest'

const Checkout = (() => {
  const manageBillingInfos = () => {
    const typology = document.querySelector('.js-checkout-billing-typology')
    const country = document.querySelector('.js-checkout-country')
    const companyData = document.querySelector('.js-checkout-billing-typology-company')
    const companyCode = document.querySelector('.js-checkout-code-company')
    const privateCode = document.querySelector('.js-checkout-code-private')
    const completeReload = document.querySelector('.js-checkout-complete-reload')
    const code = document.querySelector('.js-checkout-code')
    const codeInput = document.querySelector('.js-checkout-code input')
    if (!typology || !country || !companyData || !completeReload) return

    const completeReloadUrl = completeReload.getAttribute('href')
    function updateComplete() {
      const params = `?typology=${typology.value}&country=${country.value}`
      completeReload.setAttribute('href', completeReloadUrl + params)
      completeReload.click()
    }

    $(typology).selectize({
      onChange: (value) => {
        if (value === 'private') {
          companyData.classList.add('u-d-none')
          companyCode.classList.add('u-d-none')
          privateCode.classList.remove('u-d-none')

          if (country.value == 'OTHER') {
            code.classList.add('u-d-none')
            codeInput.removeAttribute('required')
          }
        } else if (value === 'company') {
          companyData.classList.remove('u-d-none')
          companyCode.classList.remove('u-d-none')
          privateCode.classList.add('u-d-none')
          code.classList.remove('u-d-none')
          codeInput.setAttribute('required', 'true')
        }

        updateComplete()
      }
    })

    $(country).selectize({
      onChange: (value) => {
        if (value === 'OTHER' && typology.value == 'private') {
          code.classList.add('u-d-none')
          codeInput.removeAttribute('required')
        } else {
          code.classList.remove('u-d-none')
          codeInput.setAttribute('required', 'true')
        }

        updateComplete()
      }
    })
  }

  const managePaypalPayment = () => {
    const paypalButton = document.querySelector('.js-checkout-paypal')
    if (!paypalButton) return

    paypal.Button.render({
      env: paypalButton.getAttribute('data-env'),

      payment: () => new paypal.Promise((resolve, reject) => {
        reqwest({
          url: paypalButton.getAttribute('data-url-create'),
          method: 'post',
          data: {
            order_uuid: paypalButton.getAttribute('data-order'),
          },
          success: (response) => {
            if (response.result) {
              resolve(response.payment_id)
            } else {
              reject(new Error('There was an error'))
            }
          },
        })
      }),

      onAuthorize: (data) => {
        reqwest({
          url: paypalButton.getAttribute('data-url-execute'),
          method: 'post',
          data: {
            order_uuid: paypalButton.getAttribute('data-order'),
            payment: data.paymentID,
            payer: data.payerID,
          },
          success: (response) => {
            if (response.result) {
              location.reload()
            } else {
              alert(response.error)
              location.reload()
            }
          },
        })
      }
    }, paypalButton)
  }

  const init = () => {
    manageBillingInfos()
    managePaypalPayment()
  }

  return {
    init,
  }
})()

export default Checkout



// WEBPACK FOOTER //
// app/javascript/scripts/components/Checkout.js